<template>
  <div class="pb-6">
    <header class="h2 text-secondary mb-4">
      Filter:
    </header>
    <main class="flex flex-wrap">
      <section class="mr-4 mb-4 lg:mb-0">
        <search-field v-model="selection.q" label="Zoek op titel of auteur"/>
      </section>
      <div class="flex flex-wrap">
        <select-box
          v-model="selection.year"
          :options="years"
          filter-bar
          label="Jaartal:"
          class="mr-4 mb-4 sm:mb-0"
        />
        <select-box
          v-model="selection.month"
          :options="months"
          filter-bar
          label="Maand:"
        />
      </div>
    </main>
  </div>
</template>

<script>
import SelectBox from '~/components/forms/SelectBox';
import SearchField from '~/components/forms/SearchField';

export default {
  name: 'FilterBarBlogs',
  components: {SearchField, SelectBox},
  data: () => ({
    selection: {
      q: null,
      year: null,
      month: null,
    },
    months: [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Augustus',
      'September',
      'Oktober',
      'November',
      'December',
    ],
  }),
  computed: {
    years() {
      const years = [];
      const current = this.$moment().year();

      for (let i = 0; i < 5; i++) {
        years.push(current - i);
      }

      return years;
    },
  },
  watch: {
    selection: {
      deep: true,
      handler() {
        this.$emit('new-query', this.selection);
      },
    },
  },
};
</script>
